import { Component, OnInit, ViewChild, Input, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'fury-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CategoryListComponent implements OnInit {
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;  dataSource: MatTableDataSource<any[]> = new MatTableDataSource<any[]>([]);
  
  @Input() displayedColumns = [
    { name: 'Image', property: 'image', visible: true },
    { name: 'Title', property: 'title', visible: true, isModelProperty: true },
    { name: 'Description', property: 'description', visible: true },
    { name: 'Action', property: 'actions', visible: true },
  ];
  categoryList: any;
  searchBy: string = 'title';
  searchType: string = 'contains';
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });

  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    public commonService: CommonService
  ) {
    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.searchBy = res.searchBy ? res.searchBy : 'title';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });        
    });
  }

  get visibleColumns() {
    return this.displayedColumns.filter(column => column.visible).map(column => column.property);
  }

  ngOnInit() {
    this.getCategoryList();
  }

  getCategoryList() {
    this.apiservice.get(`admin/home-owner/category/get-all-home-owner-categories?page=${this.pageIndex + 1}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`).subscribe((res: any) => {
      if (res.body) {
        if (res.body.homeOwnerCategories.data) {
          res.body.homeOwnerCategories.data.map((item: any) => {
            if (item.description.length > 50) {
              item.description = item.description.slice(0, 50) + '...';
            }  if (item.title.length > 25) {
              item.title = item.title.slice(0, 25) + '...';
            }
            return item;
          });
          this.categoryList = res.body.homeOwnerCategories.data;
          this.totalCount = res.body.homeOwnerCategories.total;

          this.dataSource = new MatTableDataSource(res.body.homeOwnerCategories.data);
          this.cdr.detectChanges();
        } else {
        }
      } else {

      }
    }, err => {
      if (err) {
        this.apiservice.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
      }
    });
  }

  deleteCategory(type: string, homeOwnerCategoryId: string) {
    const dialogref = this.dialog.open(ContentActionComponent, { width: '500px', data: { type } });
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.apiservice.delete(`admin/home-owner/category/delete-home-owner-category/${homeOwnerCategoryId}`).subscribe((del: any) => {
          if (del.body) {
            this.apiservice.alert(del.body.message, ErrorType.Success);
            this.getCategoryList();
          }
        }, err => {
          if (err) {
            this.apiservice.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
          }
        });
      }
    });
  }

  onFilterChange(value: string) {
    if (!this.dataSource) { return } else {
      this.pageIndex = 0;
      this.searchedKeyword = value.trim();
    this.router.navigateByUrl(`/homeowner/category/category-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
      this.getCategoryList();
    }
  }

  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(`/homeowner/category/category-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.getCategoryList();
  }
  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: any[] = [
    {title: 'Title', value: 'title'},
    {title: 'Description', value: 'description'}
  ];
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/homeowner/category/category-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getCategoryList();
  }

}
